'use strict';

module.exports = {
  template: require('./cn-agreement-answer.html'),
  controllerAs: 'vm',
  transclude: true,
  bindings: {
    titleText: '@',
    titleIcon: '@',
    panelClass: '@'
  }
};



/*****************
 ** WEBPACK FOOTER
 ** ./src/app/app/components/cn-agreement-answer/index.js
 ** module id = 120
 ** module chunks = 0
 **/